var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTotalBid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.44928C10.7648 1.44928 0 11.889 0 24.7246C0 37.5602 10.7648 48 24 48C37.2352 48 48 37.5602 48 24.7246C48 11.889 37.2352 1.44928 24 1.44928ZM24 46.6449C11.5383 46.6449 1.39723 36.8101 1.39723 24.7246C1.39723 12.6392 11.5383 2.80432 24 2.80432C36.4617 2.80432 46.6028 12.6353 46.6028 24.7246C46.6028 36.814 36.4657 46.6449 24 46.6449Z",
    fill: "#003C93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 2.12486C11.1496 2.12486 0.700684 12.2622 0.700684 24.7247C0.700684 37.1871 11.1536 47.3244 24.0041 47.3244C36.8546 47.3244 47.3035 37.1871 47.3035 24.7247C47.3035 12.2622 36.8505 2.12486 24 2.12486Z",
    fill: "url(#paint0_linear_913_31082)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M46.4125 30.9186C46.9916 28.9469 47.3035 26.8691 47.3035 24.7207C47.3035 22.5723 46.9916 20.4945 46.4125 18.5228V21.3154C40.4712 18.6485 5.88057 20.2353 1.55927 20.4435V19.6658H1.28793C0.903181 21.2918 0.700684 22.9807 0.700684 24.7168C0.700684 26.8259 1.00038 28.8644 1.55927 30.8007V22.0735C2.26801 24.5793 3.70575 29.3946 4.95313 31.9947H3.5478V35.5336C5.63352 39.2295 8.75603 42.297 12.5265 44.3787V38.7425C14.1911 39.8069 15.9366 40.777 17.5242 41.4211V46.425C19.5815 47.0023 21.7523 47.3126 24 47.3126C26.2478 47.3126 28.4185 47.0023 30.4759 46.425V39.689C32.1688 39.0724 33.8617 38.4047 35.3844 37.7606V44.4258C39.1469 42.3756 42.2613 39.3434 44.3632 35.6867V31.9947H43.4803C44.5981 30.2862 45.6875 28.1574 46.4125 26.1189V30.9107V30.9186Z",
    fill: "url(#paint1_linear_913_31082)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 -1.52588e-05C11.1496 -1.52588e-05 0.700684 10.1373 0.700684 22.5998C0.700684 35.0623 11.1536 45.1996 24.0041 45.1996C36.8546 45.1996 47.3035 35.0623 47.3035 22.5998C47.3035 10.1373 36.8505 -1.52588e-05 24 -1.52588e-05Z",
    fill: "url(#paint2_linear_913_31082)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 6.17033C27.2361 6.17033 29.9171 3.8805 30.4315 0.883694C28.3863 0.314183 26.2317 -3.05176e-05 24.0002 -3.05176e-05C21.7686 -3.05176e-05 19.6141 0.310255 17.5688 0.883694C18.0832 3.8805 20.7602 6.17033 24.0002 6.17033Z",
    fill: "url(#paint3_linear_913_31082)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 38.7268C20.6591 38.7268 17.9132 41.1619 17.5244 44.304C19.5818 44.8814 21.7526 45.1996 24.0003 45.1996C26.248 45.1996 28.4188 44.8853 30.4762 44.304C30.0914 41.1658 27.3415 38.7268 24.0003 38.7268Z",
    fill: "url(#paint4_linear_913_31082)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05925 22.5998C7.05925 19.4616 4.69813 16.8614 1.60802 16.3626C1.02077 18.3461 0.696777 20.4356 0.696777 22.5998C0.696777 24.7639 1.01672 26.8534 1.60802 28.8369C4.69813 28.3381 7.05925 25.738 7.05925 22.5998Z",
    fill: "url(#paint5_linear_913_31082)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9409 22.5998C40.9409 25.7419 43.302 28.3381 46.3922 28.8369C46.9794 26.8534 47.3034 24.7639 47.3034 22.5998C47.3034 20.4356 46.9834 18.3461 46.3922 16.3626C43.302 16.8614 40.9409 19.4616 40.9409 22.5998Z",
    fill: "url(#paint6_linear_913_31082)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8705 10.9385C38.175 13.1734 41.7754 13.3815 44.3268 11.5709C42.1884 7.87888 39.0133 4.81924 35.182 2.78078C33.3515 5.25521 33.5742 8.71548 35.8665 10.9385H35.8705Z",
    fill: "url(#paint7_linear_913_31082)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1298 33.9586C9.78492 31.6845 6.10756 31.5077 3.54395 33.4166C5.65397 37.1518 8.82103 40.2468 12.6523 42.3284C14.657 39.8461 14.4869 36.2445 12.1298 33.9586Z",
    fill: "url(#paint8_linear_913_31082)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9113 10.9385C14.1752 8.74296 14.4223 5.33375 12.6646 2.86717C8.86572 4.9292 5.72296 7.98492 3.60889 11.6809C6.15226 13.3737 9.65141 13.1302 11.9113 10.9385Z",
    fill: "url(#paint9_linear_913_31082)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8708 34.1746C33.5582 36.4134 33.3517 39.9168 35.2309 42.3952C39.0621 40.341 42.2332 37.2735 44.3635 33.5697C41.808 31.7316 38.1873 31.928 35.8708 34.1785V34.1746Z",
    fill: "url(#paint10_linear_913_31082)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.59459C36.6237 1.59459 46.9309 11.3823 47.2832 23.5463C47.2913 23.3303 47.2994 23.1182 47.2994 22.9022C47.2994 10.4397 36.8465 0.30632 24 0.30632C11.1536 0.30632 0.700684 10.4436 0.700684 22.9061C0.700684 23.1221 0.712833 23.3342 0.716883 23.5502C1.06923 11.3863 11.3723 1.59459 24 1.59459Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M24 43.7738C11.3966 43.7738 1.10568 34.0175 0.716883 21.8889C0.708783 22.1245 0.700684 22.3602 0.700684 22.5998C0.700684 35.0623 11.1536 45.1996 24.0041 45.1996C36.8546 45.1996 47.3035 35.0623 47.3035 22.5998C47.3035 22.3602 47.2913 22.1245 47.2873 21.8889C46.8985 34.0214 36.6075 43.7738 24.0041 43.7738H24Z",
    fill: "url(#paint11_linear_913_31082)"
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4.8978C14.1829 4.8978 6.19238 12.6471 6.19238 22.1677C6.19238 31.6884 14.1789 39.4377 24 39.4377C33.8211 39.4377 41.8036 31.6923 41.8036 22.1677C41.8036 12.6432 33.8171 4.8978 24 4.8978Z",
    fill: "#003C93"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9673 4.8978C14.1502 4.8978 6.15967 12.6471 6.15967 22.1677C6.15967 31.6884 14.1462 39.4377 23.9673 39.4377C33.7884 39.4377 41.7709 31.6923 41.7709 22.1677C41.7709 12.6432 33.7844 4.8978 23.9673 4.8978Z",
    fill: "#003C93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9675 40.2036C13.713 40.2036 5.37012 32.1126 5.37012 22.1677C5.37012 12.2229 13.713 4.12798 23.9675 4.12798C34.2219 4.12798 42.5648 12.219 42.5648 22.1638C42.5648 32.1087 34.2219 40.1997 23.9675 40.1997V40.2036ZM23.9675 5.66369C14.5878 5.66369 6.95365 13.0673 6.95365 22.1638C6.95365 31.2603 14.5878 38.6639 23.9675 38.6639C33.3472 38.6639 40.9813 31.2603 40.9813 22.1638C40.9813 13.0673 33.3472 5.66369 23.9675 5.66369Z",
    fill: "#003C93"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0305 10.7027C21.2985 9.77969 22.4811 7.41523 21.9343 5.16861C20.3306 5.35321 18.7268 5.74598 17.1635 6.38226C15.6002 7.01854 14.1868 7.85121 12.9272 8.8292C14.1949 10.7812 16.7625 11.6218 19.0305 10.6988V10.7027Z",
    fill: "url(#paint12_linear_913_31082)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8838 33.4991C26.5429 34.4496 25.3603 36.9397 26.0367 39.2452C27.6526 39.0646 29.2685 38.6679 30.8399 38.0277C32.4113 37.3875 33.8369 36.5509 35.1004 35.5572C33.8814 33.4676 31.2206 32.5446 28.8797 33.4951L28.8838 33.4991Z",
    fill: "url(#paint13_linear_913_31082)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1413 27.0302C11.1896 24.8346 8.75149 23.6838 6.43896 24.214C6.62931 25.7694 7.03431 27.3248 7.6904 28.8408C8.34649 30.3569 9.20508 31.7277 10.2176 32.9492C12.2304 31.7198 13.0971 29.2297 12.1453 27.0302H12.1413Z",
    fill: "url(#paint14_linear_913_31082)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8661 17.3838C36.8178 19.5833 39.2559 20.7302 41.5725 20.2C41.3821 18.6446 40.9771 17.0893 40.321 15.5732C39.665 14.0571 38.8064 12.6863 37.7939 11.4648C35.7811 12.6942 34.9144 15.1883 35.8661 17.3838Z",
    fill: "url(#paint15_linear_913_31082)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.783 10.6636C31.0752 11.5709 33.6551 10.6911 34.8984 8.69976C32.2821 6.72415 29.1353 5.48693 25.8346 5.14915C25.3 7.40363 26.5069 9.76023 28.783 10.6675V10.6636Z",
    fill: "url(#paint16_linear_913_31082)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1317 33.5423C16.803 32.6193 14.1706 33.5423 12.9556 35.6043C15.5637 37.6192 18.7186 38.8839 22.0315 39.2492C22.6835 36.9397 21.4767 34.4692 19.1317 33.5383V33.5423Z",
    fill: "url(#paint17_linear_913_31082)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0079 17.482C12.9272 15.2983 12.0727 12.8435 10.0922 11.618C8.05512 14.1435 6.77939 17.1796 6.41895 20.365C8.71122 20.8284 11.0885 19.658 12.0079 17.482Z",
    fill: "url(#paint18_linear_913_31082)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8176 26.932C34.878 29.159 35.7933 31.6688 37.8587 32.8706C39.9202 30.3412 41.2121 27.2894 41.5806 24.0884C39.2357 23.5307 36.7612 24.6972 35.8176 26.932Z",
    fill: "url(#paint19_linear_913_31082)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9433 7.4985C15.6045 7.4985 8.8208 14.0813 8.8208 22.1683C8.8208 30.2554 15.6045 36.8382 23.9433 36.8382C32.2822 36.8382 39.0658 30.2593 39.0658 22.1683C39.0658 14.0773 32.2822 7.4985 23.9433 7.4985Z",
    fill: "url(#paint20_linear_913_31082)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0566 36.8179C15.9162 36.8179 9.26213 30.5494 8.94623 22.7294C8.93813 22.9219 8.93408 23.1143 8.93408 23.3068C8.93408 31.3938 15.7177 37.9766 24.0566 37.9766C32.3954 37.9766 39.1791 31.3978 39.1791 23.3068C39.1791 23.1143 39.1751 22.9219 39.167 22.7294C38.8511 30.5494 32.197 36.8179 24.0566 36.8179Z",
    fill: "#003C93"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9433 8.25592C32.1485 8.25592 38.8471 14.6305 39.0577 22.5408C39.0577 22.4152 39.0658 22.2895 39.0658 22.1638C39.0658 14.0767 32.2822 7.49396 23.9433 7.49396C15.6045 7.49396 8.8208 14.0767 8.8208 22.1638C8.8208 22.2934 8.8289 22.4191 8.8289 22.5448C9.03545 14.6345 15.7341 8.25592 23.9433 8.25592Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 5.93469C33.6387 5.93469 41.5078 13.4051 41.7913 22.6823C41.7953 22.5094 41.8034 22.3366 41.8034 22.1638C41.8034 12.6431 33.8169 4.89386 23.9999 4.89386C14.1828 4.89386 6.19629 12.6471 6.19629 22.1638C6.19629 22.3366 6.20439 22.5094 6.20844 22.6823C6.49194 13.4012 14.361 5.93469 23.9999 5.93469Z",
    fill: "#003C93"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1196 28.6407H31.2533L31.1196 28.6366V28.6407Z",
    fill: "url(#paint21_linear_913_31082)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_913_31082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1321 32.3564C23.7283 32.3564 21.3245 32.3631 18.9207 32.3519C18.5372 32.3519 18 32.5141 18 31.8473C18 31.1804 18.5349 31.3562 18.9207 31.3381C19.3431 31.3179 19.8069 31.3922 19.7679 30.7457C19.7472 30.3988 19.9653 30.2951 20.273 30.2996C20.6151 30.3041 20.9204 30.2118 20.8676 29.8108C20.739 28.8218 21.3704 28.8534 22.0707 28.8579C24.8189 28.8759 27.5671 28.8759 30.313 28.8579C30.9375 28.8534 31.3783 28.9435 31.2888 29.6982C31.2383 30.1284 31.4679 30.3086 31.8972 30.2996C32.1268 30.2951 32.4161 30.3177 32.4092 30.6083C32.3908 31.4395 32.974 31.3359 33.5043 31.3314C33.8763 31.3291 34.1954 31.3674 34.1793 31.8608C34.161 32.3586 33.8166 32.3564 33.4607 32.3564C31.0179 32.3564 28.575 32.3564 26.1344 32.3564H26.1321Z",
    fill: "url(#paint22_linear_913_31082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0074 21.5714C24.2464 19.8458 22.4831 18.1203 20.7222 16.3947C21.5923 14.6556 23.1122 13.5495 24.6803 12.4929C26.4482 14.2253 28.216 15.9576 29.9839 17.6922C30.0206 18.0617 29.8622 18.3545 29.5821 18.5731C28.7166 19.2511 27.9979 20.0711 27.2288 20.8438C26.9028 21.1727 26.5814 21.603 26.0074 21.5714Z",
    fill: "url(#paint23_linear_913_31082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2984 20.0666C23.3328 20.6118 23.094 20.7695 22.915 20.9542C20.0519 23.912 17.1752 26.8586 14.3351 29.8367C13.8851 30.3098 13.5935 30.3728 13.1803 29.857C12.9713 29.5934 12.7142 29.3569 12.4456 29.1496C11.8945 28.7283 11.8922 28.3859 12.4249 27.9038C15.4555 25.1668 18.4586 22.4027 21.4777 19.6521C21.7119 19.4381 21.9346 19.0213 22.3226 19.2534C22.7359 19.5012 23.0688 19.8706 23.2984 20.0666Z",
    fill: "url(#paint24_linear_913_31082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6806 12.4929C23.1125 13.5517 21.5926 14.6578 20.7224 16.3947C19.9211 16.3856 18.9247 17.0367 18.4563 15.8517C18.05 14.8245 19.0257 14.419 19.5561 13.8603C20.4882 12.8781 21.4893 11.959 22.4512 11.0039C22.9104 10.5488 23.4178 10.2132 24.063 10.5691C24.6875 10.916 24.9515 11.4499 24.6461 12.1618C24.6071 12.2519 24.6668 12.3803 24.6829 12.4907L24.6806 12.4929Z",
    fill: "url(#paint25_linear_913_31082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0076 21.5714C26.5816 21.603 26.9007 21.1727 27.2291 20.8438C27.9982 20.0689 28.7168 19.2511 29.5824 18.5731C29.8625 18.3545 30.0209 18.0617 29.9842 17.6922C30.7212 17.7891 31.6625 17.3521 32.078 18.3298C32.5143 19.357 31.5592 19.7805 31.0173 20.3437C30.076 21.3214 29.0819 22.2473 28.1153 23.2024C27.6446 23.6687 27.1946 24.1148 26.4462 23.6642C25.7413 23.2407 25.7505 22.6753 25.9962 22.0175C26.0444 21.8846 26.0076 21.7224 26.0099 21.5737L26.0076 21.5714Z",
    fill: "url(#paint26_linear_913_31082)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_913_31082",
    x: 12,
    y: 10.2943,
    width: 22.5,
    height: 24.1262,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.923077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.235294 0 0 0 0 0.576471 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_913_31082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_913_31082",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.923077
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_913_31082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_913_31082",
    x1: 24.2957,
    y1: 44.0841,
    x2: 24.1357,
    y2: 32.8941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#033B8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5298FD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_913_31082",
    x1: 0.700684,
    y1: 32.9256,
    x2: 47.2994,
    y2: 32.9256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_913_31082",
    x1: 34.7729,
    y1: 59.0367,
    x2: 16.0237,
    y2: -8.39172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#589AF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01327A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_913_31082",
    x1: 17.5688,
    y1: 3.08712,
    x2: 30.4315,
    y2: 3.08712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_913_31082",
    x1: 17.5244,
    y1: 41.9632,
    x2: 30.4762,
    y2: 41.9632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_913_31082",
    x1: 0.000186082,
    y1: 22.5998,
    x2: 7.05925,
    y2: 22.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_913_31082",
    x1: 40.9409,
    y1: 22.5998,
    x2: 0.404963,
    y2: 22.5998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_913_31082",
    x1: 33.963,
    y1: 7.78462,
    x2: 44.3268,
    y2: 7.78462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_913_31082",
    x1: 3.548,
    y1: 37.2185,
    x2: 14.0414,
    y2: 37.2185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_913_31082",
    x1: 3.60889,
    y1: 7.82781,
    x2: 13.8188,
    y2: 7.82781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_913_31082",
    x1: 33.9632,
    y1: 37.356,
    x2: 44.3635,
    y2: 37.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_913_31082",
    x1: 0.700684,
    y1: 33.5423,
    x2: 47.3035,
    y2: 33.5423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_913_31082",
    x1: 12.9272,
    y1: 8.12614,
    x2: 22.0639,
    y2: 8.12614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_913_31082",
    x1: 25.8504,
    y1: 36.1856,
    x2: 35.1045,
    y2: 36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_913_31082",
    x1: 6.43491,
    y1: 28.5188,
    x2: 12.526,
    y2: 28.5188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_913_31082",
    x1: 35.4773,
    y1: 15.8952,
    x2: 41.5684,
    y2: 15.8952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_913_31082",
    x1: 25.7091,
    y1: 8.08312,
    x2: 34.8984,
    y2: 8.08312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_913_31082",
    x1: 12.9596,
    y1: 36.217,
    x2: 22.2057,
    y2: 36.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_913_31082",
    x1: 6.41895,
    y1: 16.0406,
    x2: 12.3764,
    y2: 16.0406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_913_31082",
    x1: 35.449,
    y1: 28.4088,
    x2: 41.5806,
    y2: 28.4088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_913_31082",
    x1: 29.8117,
    y1: 41.8813,
    x2: 20.8345,
    y2: 9.81836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034AB1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_913_31082",
    x1: 31.1196,
    y1: 28.6366,
    x2: 31.2533,
    y2: 28.6366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0142A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_913_31082",
    x1: 26.09,
    y1: 29.1874,
    x2: 26.09,
    y2: 32.0722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5C9EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_913_31082",
    x1: 25.3557,
    y1: 13.3476,
    x2: 25.3557,
    y2: 20.8052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5C9EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_913_31082",
    x1: 17.6653,
    y1: 20.2236,
    x2: 17.6653,
    y2: 29.2853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5C9EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_913_31082",
    x1: 21.5666,
    y1: 10.9983,
    x2: 21.5666,
    y2: 16.0454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5C9EFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_913_31082",
    x1: 29.0168,
    y1: 18.2572,
    x2: 29.0168,
    y2: 23.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#5C9EFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalBid);
export default __webpack_public_path__ + "static/media/icon-total-bid.4de66d4626f34943f5a028bb21e1dd8b.svg";
export { ForwardRef as ReactComponent };